import Highlighter from 'react-highlight-words'
import { type FC } from 'react'
import styles from './styles.module.scss'

type IHighlighterTextProps = {
  search: string
  text: string
}

export const HighlighterText: FC<IHighlighterTextProps> = ({ search, text }) => {
  return (
    <Highlighter
      highlightClassName={styles.highlighter}
      searchWords={search.split(' ')}
      autoEscape={true}
      textToHighlight={text}
    />
  )
}
